/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_End_Event_Comma_LabelInputs */

const en_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End event on comma`)
};

const fr_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer l'evenement sur virgule`)
};

const de_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis bei Komma beenden`)
};

const it_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina l'evento con la virgola`)
};

const ru_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершить событие на запятой`)
};

const es_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento final en coma`)
};

const zh_cn2_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以逗号结束事件`)
};

const ja_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマでイベントを終了`)
};

const hi_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अल्पविराम पर घटना समाप्त करें`)
};

const pt_pt2_plain_text_import_end_event_comma_label = /** @type {(inputs: Plain_Text_Import_End_Event_Comma_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim do evento na vírgula`)
};

/**
* | output |
* | --- |
* | "End event on comma" |
*
* @param {Plain_Text_Import_End_Event_Comma_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_end_event_comma_label = /** @type {((inputs?: Plain_Text_Import_End_Event_Comma_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_End_Event_Comma_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_end_event_comma_label(inputs)
	if (locale === "de") return de_plain_text_import_end_event_comma_label(inputs)
	if (locale === "it") return it_plain_text_import_end_event_comma_label(inputs)
	if (locale === "ru") return ru_plain_text_import_end_event_comma_label(inputs)
	if (locale === "es") return es_plain_text_import_end_event_comma_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_end_event_comma_label(inputs)
	if (locale === "ja") return ja_plain_text_import_end_event_comma_label(inputs)
	if (locale === "hi") return hi_plain_text_import_end_event_comma_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_end_event_comma_label(inputs)
	return en_plain_text_import_end_event_comma_label(inputs)
});